import defaultErrorHandler from "actions/global/default-error-handler";
import settings from "utils/settings";

import { requestCommonFilters, requestCommonSearch } from "../../common/requests";
import {
  POWER_BANK_RENT_ERROR,
  POWER_BANK_RENT_LOADING,

  POWER_BANK_RENT_FILTERS,
  POWER_BANK_RENT_LIST
} from "./constants";

const chargerUrl = `${settings.chargerUrl}api/`;
const ENDPOINT = "admin/rent";

export const setLoading = (status) => ({
  type: POWER_BANK_RENT_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, chargerUrl)
    .then((response) => {
      dispatch({
        type: POWER_BANK_RENT_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, POWER_BANK_RENT_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, chargerUrl)
    .then((response) => {
      dispatch({
        type: POWER_BANK_RENT_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, POWER_BANK_RENT_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/chargers/rent/actions.js